/**
 * Created by daniel.merkle on 06.09.2016.
 */
jQuery(document).ready(function($) {

    $('a[href*="mailto:"]').each(function(){
        var href = $(this).attr("href");
        href = href.substr(href.indexOf("mailto:"), href.length);
        $(this).attr("href", href);
    });
});